import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/body-fat-calculator/pages/CalculatorPage";

export const Route = createFileRoute("/body-fat-calculator")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/body-fat-calculator",
      title: m.bf_meta_title(),
      description: m.bf_meta_description(),
      toolName: m.bf_tool_name(),
      faqs: [
        { q: m.bf_faq_q1(), a: m.bf_faq_a1() },
        { q: m.bf_faq_q2(), a: m.bf_faq_a2() },
        { q: m.bf_faq_q3(), a: m.bf_faq_a3() },
        { q: m.bf_faq_q4(), a: m.bf_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
